export default __webpack_public_path__ + "static/media/630.191c2eba.jpg";